import { create } from 'zustand';
import api from '../api/api';

const useAuthStore = create((set, get) => ({
  user: null,
  isAuthenticated: false,
  isLoading: true, // 앱 시작 시 초기화를 위해 true로 설정

  // 로그인 함수
  login: async (formData) => {
    try {
      const res = await api.post('/auth/login', formData);
      set({
        user: res.data.user,
        isAuthenticated: true,
      });
      localStorage.setItem('accessToken', res.data.access_token);
      return { success: true };
    } catch (err) {
      return {
        success: false,
        message: err.response?.data?.detail || err.response?.data?.message || '로그인에 실패했습니다.',
      };
    }
  },

  // 로그아웃 함수
  logout: async () => {
    try {
      await api.post('/auth/logout');
      localStorage.removeItem('accessToken');
    } finally {
      set({
        user: null,
        isAuthenticated: false,
        isLoading: false,
      });
    }
  },

  // 유저 정보 가져오기 (세션 유지용)
  fetchMe: async () => {
    try {
      set({ isLoading: true });
      const { isAuthenticated } = get();
      
      // 이미 인증된 상태에서만 API 호출
      if (isAuthenticated) {
        const res = await api.get('/auth/me');
        set({ user: res.data, isAuthenticated: true });
      }
    } catch (err) {
      set({ user: null, isAuthenticated: false });
    } finally {
      set({ isLoading: false });
    }
  },

  // 유저 정보 업데이트 함수 (토큰 갱신 시 사용)
  updateUser: (userData) => {
    set({
      user: userData,
      isAuthenticated: userData !== null,
      isLoading: false,
    });
  },
}));

export default useAuthStore;
